import Username from "../../common/Username";

const DataBlock = ({title, threadReads}) => {
	return (
		<div className="mb-4 border border-borderColor rounded-lg">
			<div className="block-minorHeader">{title}</div>

			<div className="p-2 flex flex-wrap whitespace-nowrap gap-x-2">
				{threadReads.map((threadRead, index) => (<Username user={threadRead.User}/>))}
			</div>
		</div>
	);
}

const UserReadStats = ({userReadData}) => {
	const stats = userReadData.who_view_read_stats
		? userReadData.who_view_read_stats
		: {total: 0, members: 0, guests: 0};

	return (
		<div>
			<DataBlock
				title={`Ai đã đọc bài viết này (Tổng số: ${userReadData.who_has_read ? Object.values(userReadData.who_has_read).length : 0})`}
				threadReads={userReadData.who_has_read ? Object.values(userReadData.who_has_read) : []}
			/>

			<DataBlock
				title={`Ai đang xem bài viết này (Tổng số: ${stats.total}, Thành viên: ${stats.members}, Khách: ${stats.guests})`}
				threadReads={userReadData.who_view_read_list ? Object.values(userReadData.who_view_read_list) : []}
			/>

			<DataBlock
				title={`Ai đã xem bài viết này (Tổng số: ${userReadData.who_has_watch ? Object.values(userReadData.who_has_watch).length : 0})`}
				threadReads={userReadData.who_has_watch ? Object.values(userReadData.who_has_watch) : []}
			/>
		</div>
	);
}

export default UserReadStats;